import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectComponent implements OnInit {
  project:{type: string, id:number};

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.project = {
      type:this.route.snapshot.params['type'],
      id:this.route.snapshot.params['id']
    };
  }

  projects = [
    {
      id:"0",
      image: "./assets/images/blog-1.jpg",
      name:"Project 1",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing",
      gallary:[
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'},
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'}
      ],
      reviews:[
        {'name':'Rajesh Sharma','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Vivek Jain','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Prakash Shah','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'}
      ]
    },
    {
      id:"1",
      image: "./assets/images/blog-2.jpg",
      name:"Project 2",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing",
      gallary:[
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'},
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'}
      ],
      reviews:[
        {'name':'Rajesh Sharma','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Vivek Jain','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Prakash Shah','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'}
      ]
    },
    {
      id:"2",
      image: "./assets/images/blog-3.jpg",
      name:"Project 3",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing",
      gallary:[
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'},
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'}
      ],
      reviews:[
        {'name':'Rajesh Sharma','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Vivek Jain','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Prakash Shah','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'}
      ]
    },
    {
      id:"3",
      image: "./assets/images/blog-1.jpg",
      name:"Project 4",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing",
      gallary:[
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'},
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'}
      ],
      reviews:[
        {'name':'Rajesh Sharma','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Vivek Jain','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Prakash Shah','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'}
      ]
    },
    {
      id:"4",
      image: "./assets/images/blog-2.jpg",
      name:"Project 5",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing",
      gallary:[
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'},
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'}
      ],
      reviews:[
        {'name':'Rajesh Sharma','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Vivek Jain','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Prakash Shah','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'}
      ]
    }
  ];

  activeProject = {
      id:"28765490",
      image: "./assets/images/blog-1.jpg",
      name:"Project 1",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing",
      gallary:[
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'},
        {'title':'image','src':'./assets/images/blog-1.jpg'},
        {'title':'image','src':'./assets/images/blog-2.jpg'},
        {'title':'image','src':'./assets/images/blog-3.jpg'}
      ],
      reviews:[
        {'name':'Rajesh Sharma','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Vivek Jain','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'},
        {'name':'Prakash Shah','review':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer'}
      ]
    };

    carouselOptions = {
      margin: 30,
      nav: true,
      navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
      responsiveClass: true,
      dots:false,
      autoWidth:false,
      // autoplay:true,
      loop:true,
      responsive: {
        0: {
          items: 1,
          nav: false,
        },
        600: {
          items: 1,
          nav: false
        },
        1000: {
          items: 2,
          nav: false
        },
        1200: {
          items: 2,
          nav: true
        }
      }
    }
}
